export default __webpack_public_path__ + "aa67162f657f27a998826e428c3b61a2.webp";